import styled from '@emotion/styled';
import { imageIconBaseStyles } from '@hotjar/webapp/features/Feedback/EmotionIcon/icons/settings';

import starOff from './assets/star_off.png';
import starOn from './assets/star_on.png';

export const StarIcon = styled.span<{
  index: number;
  isCompact?: boolean;
  isOn: boolean;
  size: number;
}>`
  ${imageIconBaseStyles}
  margin-right: 2px;
  background-image: url(${starOff});

  ${({ isCompact, index }) =>
    isCompact &&
    `
    margin-right: -6px;
    position: relative;
    z-index: ${5 - index};
  `}

  ${({ isOn }) =>
    isOn &&
    `
      background-image: url(${starOn});
    `}
`;
